import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { enableProtection, detectDevTools, preventDataExtraction } from './utils/security';
import { SECURITY_CONFIG } from './utils/env';

// Enable security protections in production
if (SECURITY_CONFIG.ENABLE_PROTECTION) {
  enableProtection();
  if (SECURITY_CONFIG.ENABLE_DEVTOOLS_DETECTION) {
    detectDevTools();
  }
  preventDataExtraction();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
